<template>
  <div class="sky-hc-aol">
    <!-- <el-alert class="sky-hc-aol__desc" title="表格数据每日凌晨1点更新" type="info" :closable="false"> </el-alert> -->
    <pagination-table
      ref="multipleTable"
      :data="orgList"
      :limit="limit"
      :total="count"
      :page="page"
      :hasSearch="true"
      tooltipEffect="black"
      :searchPlaceholder="$t('activeOrg.searchKeyword')"
      :defaultSort="defaultSort"
      @search="handleSearchContent"
      @prevClick="handlePrevClick"
      @nextClick="handleNextClick"
      @sizeChange="handleSizeChange"
      @sortChange="handleSortChange"
      @filterChange="filterHandler"
    >
      <template slot="columns">
        <el-table-column :label="$t('activeOrg.orgName')" prop="orgName" width="200" fixed="left" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column :label="$t('activeOrg.orgId')" prop="snId" width="80" show-overflow-tooltip> </el-table-column> -->
        <el-table-column
          prop="orgType"
          :filters="orgTypeFilers"
          :filterFooter="false"
          :label="$t('activeOrg.orgType')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.orgType ? ORG_TYPE.getLabel(scope.row.orgType) : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeName"
          :filters="tradeFilters"
          :filterFooter="false"
          :label="$t('activeOrg.industry')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.tradeName ? scope.row.tradeName : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orgArea"
          sortable="custom"
          width="160"
          :label="$t('activeOrg.area')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.orgArea ? scope.row.orgArea : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="terminalCount"
          sortable="custom"
          :label="$t('activeOrg.termianlSum')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.terminalCount ? scope.row.terminalCount : 0 }}
          </template>
        </el-table-column>
        <slot name="custom">
          <el-table-column
            prop="maintainPersonalCount"
            sortable="custom"
            :label="$t('activeOrg.orgAdminNum')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="subOrgCount"
            :label="$t('activeOrg.subOrgSum')"
            sortable="custom"
            show-overflow-tooltip
          ></el-table-column>
        </slot>
        <el-table-column
          prop="orgCreateTime"
          sortable="custom"
          width="150"
          :label="$t('activeOrg.createTime')"
          show-overflow-tooltip
          ><template slot-scope="scope">
            {{ scope.row.orgCreateTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="lastWebLoginTime"
          width="145"
          :label="$t('activeOrg.lastLoginTime')"
          show-overflow-tooltip
          ><template slot-scope="scope">
            {{ scope.row.lastWebLoginTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="lastTurnOnTime"
          :label="$t('activeOrg.lastTurnOnTime')"
          width="145"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.lastTurnOnTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastUserJoinTime"
          :label="$t('activeOrg.lastMemberAddTime')"
          width="160"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.lastUserJoinTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastAgencyTime"
          :label="$t('activeOrg.lastMaintainedTime')"
          width="160"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.lastAgencyTime | formatTime('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('whitelist.handler')" fixed="right" width="140">
          <div slot-scope="scope">
            <span class="sky-hc-aol__table-btn" @click="handleDetail(scope.row)">{{ $t('activeOrg.seeDtl') }}</span>
            <!-- <span class="sky-hc-aol__table-btn" @click="handleSeeDtl(scope.row)">{{
              $t('activeOrg.seeWhiteList')
            }}</span> -->
          </div>
        </el-table-column>
      </template>
    </pagination-table>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import { TableColumn, Alert } from 'element-ui'

import { getActiveOrganizationList, getTradeInfo } from '@/api/activeOrganization'
import { getDecentralizedOrgList } from '@/api/characteristicOrg'
import PaginationTable from '@/components/paginationTable'

import ORG_TYPE from '@/utils/orgType'
import Backtop from '@/views/components/backtop'

export default {
  name: 'activeOrganizationList',
  components: {
    PaginationTable,
    [TableColumn.name]: TableColumn,
    [Backtop.name]: Backtop,
    [Alert.name]: Alert
  },
  props: {
    isDecentralizedOrg: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      ORG_TYPE,
      orgList: [],
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      sort: {},
      defaultSort: { prop: 'orgCreateTime', order: 'descending' },
      orgTypeFilers: ORG_TYPE.getFilterArr(),
      exactMatchArr: [],
      tradeFilters: []
    }
  },
  created() {
    this.handleGetActiveOrgList()
    this.handleGetTradeInfo()
  },
  methods: {
    handleDetail(item) {
      this.$router.push({
        name: 'activeOrganizationDetail',
        query: {
          orgId: item.snId
        }
      })
    },
    handleSeeDtl(item) {
      this.$router.push({
        name: 'whitelistDetail',
        query: {
          orgId: item.snId
        },
        params: {
          isFromActiveOrg: true
        }
      })
    },
    handleGetActiveOrgList() {
      if (this.isDecentralizedOrg) {
        getDecentralizedOrgList({
          page: this.page,
          limit: this.limit,
          searchKeyword: this.keyword,
          exactMatchArr: this.exactMatchArr,
          sort: this.sort
        }).then(response => {
          this.orgList = response.data.content.itemArr
          this.count = response.data.content.total
        })
      } else {
        getActiveOrganizationList({
          page: this.page,
          limit: this.limit,
          searchKeyword: this.keyword,
          exactMatchArr: this.exactMatchArr,
          sort: this.sort
        }).then(response => {
          this.orgList = response.data.content.itemArr
          this.count = response.data.content.total
        })
      }
    },
    handleSearchContent(keyword) {
      this.page = 0
      this.keyword = keyword
      this.handleGetActiveOrgList()
    },
    handlePrevClick() {
      this.page--
      this.handleGetActiveOrgList()
    },
    handleNextClick() {
      this.page++
      this.handleGetActiveOrgList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetActiveOrgList()
    },
    handleSortChange(param) {
      this.page = 0
      this.sort = {
        sortField: param.prop,
        direction: param.order === 'ascending' ? 'ASC' : 'DESC'
      }
      this.handleGetActiveOrgList()
    },
    filterHandler(filters) {
      this.exactMatchArr = filters
      this.page = 0
      this.handleGetActiveOrgList()
    },
    handleGetTradeInfo() {
      getTradeInfo().then(response => {
        if (response.data.content && response.data.content.length) {
          this.tradeFilters = response.data.content.map(item => {
            return { text: item.name, value: item.name }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-aol) {
  padding-top: 30px;
  @include e(table-btn) {
    color: $--color-primary;
    cursor: pointer;
  }
  .el-table .cell {
    height: fit-content;
  }
  @include e(desc) {
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.sky-hc-aol {
  padding-bottom: 30px;
  .el-table__fixed,
  .el-table__fixed-right {
    height: 100% !important;
  }
}
</style>
